import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "summary", "previews"];
    static values = { removeLabel: String };

    declare readonly inputTarget: HTMLInputElement;
    declare readonly summaryTarget: HTMLElement;
    declare readonly previewsTarget: HTMLElement;
    declare readonly removeLabelValue: string;

    private previewUrls: string[] = [];

    changed(): void {
        this.render();
    }

    remove(event: Event): void {
        const button = event.currentTarget;
        if (!(button instanceof HTMLButtonElement)) return;

        const removedIndex = Number(button.dataset.index);
        const files = new DataTransfer();
        Array.from(this.inputTarget.files || []).forEach((file, index) => {
            if (index !== removedIndex) files.items.add(file);
        });
        this.inputTarget.files = files.files;
        this.render();
    }

    private render(): void {
        const files = Array.from(this.inputTarget.files || []);

        this.summaryTarget.textContent = files.length === 0
            ? "Aucune photo sélectionnée"
            : files.length === 1
                ? `1 photo sélectionnée : ${files[0].name}`
                : `${files.length} photos sélectionnées`;

        this.previewUrls.forEach((url) => URL.revokeObjectURL(url));
        this.previewUrls = files.map((file) => URL.createObjectURL(file));
        this.previewsTarget.replaceChildren(...files.map((file, index) => {
            const preview = document.createElement("div");
            preview.className = "relative";

            const image = document.createElement("img");
            image.src = this.previewUrls[index];
            image.alt = file.name;
            image.className = "h-28 w-full rounded-xl border border-border object-cover";

            const button = document.createElement("button");
            button.type = "button";
            button.textContent = "×";
            button.className = "absolute right-2 top-2 flex size-8 items-center justify-center rounded-full bg-card text-xl leading-none text-foreground shadow ring-1 ring-ring hover:bg-muted focus:outline-none focus:ring-2 focus:ring-indigo-500";
            button.dataset.action = "intake-photo-picker#remove";
            button.dataset.index = index.toString();
            button.dataset.posthogId = "intake-photo-remove";
            button.setAttribute("aria-label", `${this.removeLabelValue} ${file.name}`);

            preview.append(image, button);
            return preview;
        }));
        this.previewsTarget.hidden = files.length === 0;
    }

    disconnect(): void {
        this.previewUrls.forEach((url) => URL.revokeObjectURL(url));
    }
}
